<template>
  <div
    class="custom-alert-message"
    :style="`color:${iconColor}; border-color:${borderColor}; background-color:${backgroundColor}`"
  >
    <div
      class="custom-alert-icon"
      :style="`background-color: ${iconColor}`"
    >
      <slot name="icon" />
      <v-icon
        v-if="icon"
        small
        color="white"
      >
        {{ icon }}
      </v-icon>
    </div>
    <div class="custom-alert-text">
      <slot name="default" />
    </div>
  </div>
</template>
<script>
export default {
  name:"CustomAlert",
  props: {
    icon: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "info",
    },
    borde:{
      type:Boolean,
      default: true,
    },
    fondo:{
      type:Boolean,
      default:true
    }
  },
  computed: {
    backgroundColor() {

      if(this.fondo)
          return this.type === "info"
            ? "#e6f2ff"
            : this.type === "success"
            ? "#9af6ab"
            : this.type === "warning"
            ? "#fff3cd"
            : this.type === "error"
            ? "#ffa185"
            : "blue";
      else
        return 'white'
    },
    iconColor() {
      return this.type === "info"
        ? "blue"
        : this.type === "success"
        ? "green"
        : this.type === "warning"
        ? "#856404"
        : this.type === "error"
        ? "darkred"
        : "blue";
    },
    borderColor() {
      if (this.borde)
        return this.type === "info"
          ? "blue"
          : this.type === "success"
          ? "darkgreen"
          : this.type === "warning"
          ? "#ad8304"
          : this.type === "error"
          ? "darkred"
          : "blue";
      else
        return 'white'
    }
  }
}
</script>
<style>
/* .transition-opacity-enter-active {
  transition: opacity 0.5s;
}
.transition-opacity-enter, .transition-opacity-leave-to {
  opacity: 0;
} */
.custom-alert-message {
  display: flex;
  align-items: center;
  /* color: #856404; */
  padding: 5px;
  border-width: 1px;
  border-style: solid;
  /* border-color: #ad8304; */
  border-radius: 12px; /* Bordes redondeados */
  font-family: Arial, sans-serif;
  line-height: 1.4em;
}
.custom-alert-icon {
  /* background-color: #856404; */
  color: #fff;
  font-weight: bold;
  font-size: 15px;
  min-width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 10px;
}
.custom-alert-text {
  font-size: 12px;
}
@media (min-width: 0px) and (max-width: 719px) {
  .custom-alert-message {
    width: 100%!important;
  }
}
</style>
